export default {
    // 主面板
    back: 'Back',
    dd: 'D',
    hh: 'H',
    mm: 'm',
    ss: 's',
    send: 'Send',
    detail: 'detail', // 详情
    discuss: 'discuss', // 讨论
    content: 'content',
    duration: 'duration',
    backPlay: 'replay',
    cloudHall: 'gallery',
    enterprise: 'enterprise zone',
    conven: 'convention',
    awardQA: 'quiz with award',
    discussLoginTip: 'Sorry,login is required to participate in the discussion', // 发言登录提示
    drawLoginTip: 'Sorry,login is required', // 抽奖登录提示
    feedbackLoginTip: 'Sorry,login is required', // 意见反馈登录提示
    complainLoginTip: 'Sorry,login is required', // 投诉登录提示
    mineLoginTip: 'Sorry,login is required', // 我的资料登录提示
    toLogin: 'To log in',
    loginIn: 'Log in',
    guest: 'guest',
    countdown: 'countdown',
    widthMobile: 'Watch with phone',
    scanWx: 'Please scan with wechat',
    // 登录框
    loginMobileTitle: 'Mobile number login',
    loginEmailTitle: 'Email login',
    loginPhoneLabel: 'Phone number',
    loginPhoneTip: 'Please enter phone number',
    loginVerificationLabel: 'Verification code',
    loginVerificationTip: 'Please enter verification code',
    loginNameLabel: 'Name',
    loginNameTip: 'Enter your name',
    loginCompanyLabel: 'Unit',
    loginCompanyTip: 'Enter your unit',
    loginOfficeLabel: 'Offices',
    loginOfficeTip: 'Enter your offices',
    loginInGuest: 'Join in as a guest',
    loginGetCode: 'Send',
    areaCode: 'area code',
    // 手机绑定弹框
    bindMobileTitle: 'Phone number binding',
    bindLoginIn: 'Binding',
    bindSuccess: 'success',
    bindFail: 'fail',
    // 邮箱登录框
    loginEmailLabel: 'Email',
    loginEmailTip: 'Please enter email',
    correctEmialTip: 'Please enter the correct email and verification code',
    correctLoginTip: 'Please enter the correct phone and verification code',
    // 广告
    skip: 'Skip',
    // 抽奖
    startCountdown: 'Start countdown',
    endCountdown: 'End countdown',
    last: 'Rest',
    lastDrawNums: 'number of lucky draw',
    seeMyGift: 'View my prizes',
    drawRule: 'Lucky draw rules',
    thx: 'Thanks',
    notstart: 'Not started',
    drawNow: 'Draw now',
    drawOver: 'Run out',
    hasEnd: 'Already over',
    drawnotstart: 'Lucky draw has not started',
    drawing: 'Underway',
    drawend: 'Lucky draw is over',
    gift: 'Prizes',
    drawLessNum: 'The count of draws has run out',
    draw: 'Lucky draw',
    drawNoPerfect: 'Information is not complete',
    drawGoPerfect: 'Complete as soon as possible',
    drawResult: 'Result',
    drawFailTip: 'Unfortunately, the grand prize passed by',
    congratulations: 'Congratulations on getting',
    perfectAddress: 'Complete Receiving information',
    agreementTip: 'I agree to provide the above personal information to the event organizer',
    emailTip: 'The prize delivery information will be sent to your mailbox',
    submited: 'Submited',
    name: 'name',
    tel: 'tel',
    telTip: 'Enter your tel',
    email: 'email',
    emailResTip: 'Enter your email',
    address: 'address',
    addressTip: 'Enter your address',
    // 时长
    currentAccount: 'Current login account',
    noLogin: 'Not logged in',
    noReportDuration: 'Unreported duration',
    reportDuration: 'report',
    totalDuration: 'Cumulative viewing duration',
    RequiredViewingTime: 'Required viewing time',
    RequiredViewingTimeLIVE: 'Required viewing live time',
    RequiredViewingTimeVOD: 'Required viewing vod time',
    RequiredViewingTimeALL: 'Required viewing all time',
    Minutes: 'Minutes',
    // enterStatus: 'Credit enrollment status',
    enterStatus: 'Registration status',
    applyInfo: 'apply info',
    enterYes: 'Enrolled',
    enterNo: 'Not enrolled',
    // 姓名医院登录
    hasRead: 'Read and agree to comply',
    policy: 'Privacy agreement',
    needCheckPolicy: 'Please check the agreement',
    // 完善资料弹窗
    perfect: 'Complete information',
    perfectOfficesLabel: 'Department',
    perfectOfficesTip: 'Enter your department',
    perfectJobLabel: 'Professional titles',
    perfectJobTip: 'Enter your professional titles',
    submit: 'Submit',
    selectTypeLabel: 'Work',
    selectType: 'Please select your work',
    selectHospitalLabel: 'Hospital',
    selectHospital: 'Please select hospital',
    selectOfficeLabel: 'Office',
    selectOffice: 'Please select office',
    selectJobTitleLabel: 'Job',
    selectJobTitle: 'Please select job',
    selectSchoolLabel: 'School',
    selectSchool: 'Please select school',
    selectSpecialtyLabel: 'Specialty',
    selectSpecialty: 'Please enter Specialty',
    selectEducationLabel: 'Education',
    selectEducation: 'Please select education',
    selectUnitLabel: 'Unit',
    selectUnit: 'Please enter unit',
    selectPostLabel: 'Post',
    selectPost: 'Please enter post',
    selectSexLabel: 'Sex',
    selectSex: 'Please select sex',
    selectBirthdayLabel: 'Birthday',
    selectBirthday: 'Please select birthday',
    selectKeyword: 'Please enter keyword',
    perfectTip: 'Note: Please confirm that the above information is true and valid',
    besure: 'Ensure',
    becancel: 'Cancel',
    // 隐私条款
    sure: 'Enter',
    // 投诉反馈
    more: 'More',
    consult: 'Consulting',
    mineTitle: 'Information',
    complain: 'Complaint',
    complainReason: 'Please select the complaint reason',
    complainContent: 'Description',
    complainContentPlaceholder: 'Please describe your problems in detail and upload screenshots of related pages',
    complainDescPlaceholder: 'Please enter description',
    complainImages: 'Screenshots',
    complainImagesPlaceholder: 'Please upload at least one screenshot.',
    submitQuick: 'Submit',
    feedback: 'Feedback',
    feedbackTitle: 'Title',
    feedbackTitlePlaceholder: 'Please enter title',
    feedbackContent: 'Description',
    feedbackContentDesc: 'Please enter description',
    feedbackContentPlaceholder: 'Please describe your problems in detail and upload screenshots of relevant pages so that we can help you better',
    feedbackImages: 'Screenshots',
    feedbackSubmit: 'Submit',
    feedbackFail: 'Sorry,login is required',
    // 我的资料
    mineInfo: 'My information',
    shipAddressLabel: 'Shipping Address',
    shipAddressTip: 'Please enter address',
    mineSave: 'Save',
    mineLogout: 'Logout',
    mineLogoutTip: 'Are you sure you want to log out?',
    // 多会场
    hasNoLink: `You don't have the right to watch the live broadcast, please contact the conference group.`,
    // 无权限提示
    noauthTip: 'Tip',
    logoutDesc: 'Are you sure you want to log out?',
    noauthDesc: `Sorry, you don't have the right to watch the live broadcast. Please contact the staff or log in again`,
    noauthBtn: 'Log in again',
    // 其他
    verificationSuccess: 'success',
    verificationFail: 'fail',
    verificationTypeError : 'Type wrongly',
    verificationFrequently: 'Too often. Please try again in two minutes',
    loginSuccess: 'success',
    loginFail: 'fail',
    hospitalLoginValidFail: 'name and hospital cannot be empty or blank',
    saveSuccess: 'success',
    saveFail: 'fail',
    perfectSuccess: 'success',
    perfectFail: 'fail',
    authFail: 'failed to obtain permission. Please try again later',
    appointFail: 'fail',
    noLiveTip: 'there is no live broadcast or playback of the current meeting. Please contact the background administrator to set it up',
    submitSuccess: 'success',
    // 有奖竞答
    activityRule: 'Activity Rules',
    winnersList: 'List of winners',
    participantsList: 'List of participants',
}
